// components
import { styled, DialogActions, DialogActionsProps } from '@mui/material';
import { StyledWarningContainer } from 'components/roster-portal/activity-planning/components/EditRouteDialog/EditRouteDialog.styles';

export const StyledCustomWarningContainer = styled(StyledWarningContainer)(
  () => ({
    margin: 0,
    alignItems: 'start'
  })
);

export const StyledDialogActionsMarginTop = styled(
  DialogActions
)<DialogActionsProps>(({ theme }) => ({
  marginTop: theme.spacing(3)
}));
